import { Fragment } from 'react';
import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { CommonHexagonBadge } from '@/partials/common';

interface IntroProps {
    mode: "create" | "addSource";
}

const Intro: React.FC<IntroProps> = ({ mode }) => {
    // Set header and description based on the mode.
    const headerText =
        mode === "addSource"
            ? "Adding a Source to a Job is as Easy as This!"
            : "Adding a Job is as Easy as This!";

    const descriptionText =
        mode === "addSource"
            ? `Easily add a new source to your job posting using various methods. You can upload a job description or details, paste plain text with the job information, or include a link to the job posting from your website or other platforms. Buddy will process the information, structure it into a detailed job profile, and prepare it for candidate matching. You can also import job postings directly from popular ATS platforms and other HR or recruiting tools, making it seamless to manage job opportunities from multiple sources!`
            : `Easily add a job to Buddy using various methods. You can upload a job description or ad, paste plain text with the job details, or include a link to the job posting from your website or other platforms. Buddy will process the information, structure it into a detailed job profile, and prepare it for candidate matching. You can also import job postings directly from popular ATS platforms and other HR or recruiting tools, making it seamless to manage job opportunities from multiple sources!`;

    return (
        <Fragment>
            <style>
                {`
          .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5.png')}');
          }
          .dark .upgrade-bg {
            background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-5-dark.png')}');
          }
        `}
            </style>

            <div className="card rounded-xl">
                <div
                    className="flex items-center justify-between grow gap-2 p-5 [background-position:121%_41%] bg-no-repeat bg-[length:660px_310px] upgrade-bg"
                >
                    <div className="flex items-center gap-4">
                        <CommonHexagonBadge
                            stroke="stroke-success-clarity"
                            fill="fill-success-light"
                            size="size-[50px]"
                            badge={
                                <KeenIcon icon="information-4" className="text-xl text-success" />
                            }
                        />

                        <div className="flex flex-col gap-1.5">
                            <div className="flex items-center gap-2.5">
                                <a
                                    href="#"
                                    className="text-base font-medium text-gray-900 hover:text-primary-active"
                                >
                                    {headerText}
                                </a>
                            </div>

                            <div className="text-2sm text-gray-800">
                                {descriptionText}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export { Intro };
